import { observable } from 'mobx'
import { ControllerStoreBase } from 'src/controllers/ControllerStoreBase'
import { persist } from 'mobx-persist'
import VueJwtDecode from 'vue-jwt-decode'
import moment from 'moment'

export class GlobalController extends ControllerStoreBase {
  @persist('object') @observable authResp = { token: '', uidFirebase: '' };
  @persist('object') @observable profile = {}

  static async getAsyncInstance () {
    return await super.construct(new GlobalController(), true)
  }

  static getInstance () {
    return super.construct(new GlobalController(), true)
  }

  clearAuth () {
    this.authResp = null
  }

  setAuthResp (authResp) {
    this.authResp = authResp
    if (authResp) {
      this.authResp.exp = VueJwtDecode.decode(authResp.token).exp
    }
  }

  clearProfile () {
    this.profile = null
  }

  setProfile (profile) {
    this.profile = { ...this.profile, ...profile }
  }

  isRefreshToken () {
    if (!this.authResp.exp) {
      return false
    }
    const after = moment(this.authResp.exp * 1000)
    const before = moment(Date.now())
    const diff = after.diff(before, 'minutes')
    return diff < 15
  }

  removeExp () {
    delete this.authResp.exp
  }

  getName () {
    return 'GlobalController'
  }
}
